import React, {Component} from 'react'
import FreeSlotItem from './FreeSlotItem'
import {infoUtils} from "../../utils/infoUtils"
import no_data from '../../resources/images/no_data.png'
import {$$} from '../../helpers/localization'
import PropTypes from "prop-types";
import { sl } from 'date-fns/locale'

class FreeSlotsList extends Component {
    constructor(props) {
        super(props);
        this.index = 0;
    }


    /**
     * Prepares the slot list item by item
     *
     * @returns {Array} - the list with slot elements
     */
    getSlotListItems = () => {
        let noHoursAvailableObj = {
            imgClass: 'no-entry-image2',
            objClass: 'no-data-object',
            primaryLabelClass: 'no_hours_available_primary_label',
            secondaryLabelClass: 'no_hours_available_primary_label',
            src: no_data,
            primaryLabel: $$('no_hours_available_primary_label'),
        }

        if (this.props.slots && this.props.slots.length > 0) {
            return this.props.slots.map((slot) => {
                let selectedPrice = this.props.selectedPrice;
                let selectedDoctor = this.props.clinician
                if (slot.doctors && slot.doctors.length > 0) {
                    selectedPrice = slot.doctors[0].encounterPrice;
                    selectedDoctor = { ...slot.doctors[0], fullname: slot.doctors[0].full_name, organizations: [this.props.clinician.organizations[0]]};
                }
                //console.log('selectedPrice', selectedPrice);
                //console.log('selectedDoctor', selectedDoctor);
                return <div key={slot.start}>
                    <FreeSlotItem
                        clinician={selectedDoctor}
                        selectedPrice={selectedPrice}
                        selectedUser={this.props.selectedUser}
                        setShowExistingAppointmentPopup={this.props.setShowExistingAppointmentPopup}
                        slot={slot}
                    />
                </div>
            });
        } else {
            return infoUtils.noData(noHoursAvailableObj)
        }

    }

    render() {
        return (
            <div style={{position: 'relative'}}>
                {this.props.loading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1
                    }}>
                        <div className="med-search-loader"/>
                    </div>
                )}
                <div className='slot-items' style={this.props.loading ? {visibility: 'hidden'} : undefined}>
                    {this.getSlotListItems()}
                </div>
            </div>
        )
    }
}

FreeSlotsList.propTypes = {
    clinician: PropTypes.object,
    selectedPrice: PropTypes.object,
    slots: PropTypes.array,
    loading: PropTypes.bool
}

export default FreeSlotsList;
